/**
 * FlyFreely API
 *
 * Contact: support@flyfreely.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CheckExpiryDto } from './checkExpiryDto';
import { SimplePersonDto } from './simplePersonDto';

export interface PersonnelRegisterEntryExpiryDto {
    /**
     * The ID of the register entry. There may be multiple entries for a given entity.
     */
    id: number;
    /**
     * The ID of the authority register that this entry is attached to
     */
    authorityRegisterId: number;
    /**
     * The date that this person started being registered under this authority
     */
    startDate: string;
    /**
     * The date that this person ceased being on the register
     */
    endDate?: string;
    person: SimplePersonDto;
    /**
     * Whether the entry has expired according to the expiry rules
     */
    expiryStatus?: PersonnelRegisterEntryExpiryDto.ExpiryStatus;
    /**
     * When the entry expires, based on the soonest of all expired elements
     */
    expiryDate?: string;
    /**
     * When the expiry check was last performed
     */
    lastExpiryUpdate?: string;
    checkExpiryList: Array<CheckExpiryDto>;
}
export namespace PersonnelRegisterEntryExpiryDto {
    export type ExpiryStatus = 'OK' | 'UPCOMING' | 'EXPIRED';
    export const ExpiryStatus = {
        OK: 'OK' as ExpiryStatus,
        UPCOMING: 'UPCOMING' as ExpiryStatus,
        EXPIRED: 'EXPIRED' as ExpiryStatus
    };
}
